import { DarkMode, LightMode } from '../Icon'

export function CypressIcon() {
  return (
    <>
      <LightMode>
        <path
          id="Path"
          fill="#000000"
          stroke="none"
          d="M 11.246 12.70425 C 12.53925 12.70425 13.59025 13.394749 14.129 14.59375 L 14.1695 14.68825 L 16.338499 13.95075 L 16.29475 13.8395 C 15.456 11.7915 13.5195 10.521999 11.246 10.521999 C 9.646 10.521999 8.346 11.033749 7.27175 12.088001 C 6.204 13.1355 5.665 14.452499 5.665 16.001751 C 5.665 17.541 6.2075 18.851 7.27175 19.89525 C 8.346 20.949499 9.64625 21.46125 11.246 21.46125 C 13.5195 21.46125 15.45275 20.18825 16.29475 18.143749 L 16.338499 18.032749 L 14.166 17.29525 L 14.129 17.39275 C 13.644 18.575001 12.56625 19.278749 11.246 19.278749 C 10.34675 19.278749 9.5855 18.9655 8.986 18.345751 C 8.37625 17.7195 8.06975 16.927999 8.06975 16.001751 C 8.06975 15.06875 8.36975 14.29425 8.986 13.637249 C 9.58875 13.0175 10.34675 12.70425 11.246 12.70425"
        />
        <linearGradient
          id="linearGradient1"
          x1="33.224937"
          y1="16.102583"
          x2="18.940542"
          y2="25.351179"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.081" stopColor="#69d3a7" stopOpacity="1" />
          <stop offset="1" stopColor="#69d3a7" stopOpacity="0" />
        </linearGradient>
        <path
          id="path1"
          fill="url(#linearGradient1)"
          stroke="none"
          d="M 20.663 31.282499 L 20.0165 29.150499 C 25.85 27.379 29.77025 22.0945 29.77025 16.001751 C 29.77025 14.320999 29.470501 12.6775 28.87775 11.12125 L 30.959249 10.32975 C 31.650101 12.141994 32.00285 14.065542 32 16.004999 C 31.99675 23.081249 27.443001 29.221251 20.663 31.282499"
        />
        <path
          id="path2"
          fill="#69d3a7"
          stroke="none"
          d="M 29.1675 11.973499 C 27.38575 6.16025 22.0945 2.2565 15.99825 2.2565 C 15.171648 2.25663 14.34668 2.329916 13.533 2.4755 L 13.13875 0.283001 C 14.082468 0.113256 15.039388 0.027586 15.99825 0.027 C 23.077999 0.027 29.224751 4.563749 31.296 11.31675 Z"
        />
        <linearGradient
          id="linearGradient2"
          x1="10.672573"
          y1="0.228997"
          x2="1.698604"
          y2="19.261801"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1e-05" stopColor="#69d3a7" stopOpacity="1" />
          <stop offset="0.823" stopColor="#2ab586" stopOpacity="1" />
          <stop offset="1" stopColor="#1cae7f" stopOpacity="1" />
        </linearGradient>
        <path
          id="path3"
          fill="url(#linearGradient2)"
          stroke="none"
          d="M 1.024 21.632999 C 0.3435 19.834499 0 17.93825 0 16.001751 C 0 7.75 6.194 0.916 14.4085 0.1075 L 14.6275 2.32375 C 7.558 3.02125 2.22625 8.901749 2.22625 16.001499 C 2.224128 17.656912 2.521938 19.299013 3.10525 20.848249 Z"
        />
        <path
          id="path4"
          fill="#000000"
          stroke="none"
          d="M 16.0825 10.723999 L 20.4475 21.407499 L 17.268 29.120001 L 19.494249 29.564751 L 27.234249 10.723751 L 24.82925 10.723751 L 21.740999 18.55125 L 18.62875 10.723751 Z"
        />
        <linearGradient
          id="linearGradient3"
          x1="-0.022713"
          y1="23.315021"
          x2="23.508358"
          y2="30.699967"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.077" stopColor="#1cae7f" stopOpacity="1" />
          <stop offset="0.164" stopColor="#1ca379" stopOpacity="1" />
          <stop offset="0.316" stopColor="#1c8568" stopOpacity="1" />
          <stop offset="0.516" stopColor="#1b554d" stopOpacity="1" />
          <stop offset="0.719" stopColor="#1b1e2e" stopOpacity="1" />
        </linearGradient>
        <path
          id="path5"
          fill="url(#linearGradient3)"
          stroke="none"
          d="M 17.668751 28.150249 L 17.20075 29.28525 C 17.093 29.54475 16.847 29.723249 16.570749 29.73325 C 16.379 29.74 16.19025 29.74675 15.995 29.74675 C 9.882 29.74675 4.439 25.654499 2.7585 19.79425 L 0.61625 20.407 C 2.56975 27.214001 8.89175 31.9695 15.9915 31.973 L 15.995 31.973 C 16.217251 31.973 16.439501 31.969749 16.661751 31.959499 C 17.803499 31.9125 18.824249 31.195 19.261749 30.134001 L 19.89525 28.594999 Z"
        />
      </LightMode>
      <DarkMode>
        <path
          id="Path"
          fill="#fff"
          stroke="none"
          d="M 11.246 12.70425 C 12.53925 12.70425 13.59025 13.394749 14.129 14.59375 L 14.1695 14.68825 L 16.338499 13.95075 L 16.29475 13.8395 C 15.456 11.7915 13.5195 10.521999 11.246 10.521999 C 9.646 10.521999 8.346 11.033749 7.27175 12.088001 C 6.204 13.1355 5.665 14.452499 5.665 16.001751 C 5.665 17.541 6.2075 18.851 7.27175 19.89525 C 8.346 20.949499 9.64625 21.46125 11.246 21.46125 C 13.5195 21.46125 15.45275 20.18825 16.29475 18.143749 L 16.338499 18.032749 L 14.166 17.29525 L 14.129 17.39275 C 13.644 18.575001 12.56625 19.278749 11.246 19.278749 C 10.34675 19.278749 9.5855 18.9655 8.986 18.345751 C 8.37625 17.7195 8.06975 16.927999 8.06975 16.001751 C 8.06975 15.06875 8.36975 14.29425 8.986 13.637249 C 9.58875 13.0175 10.34675 12.70425 11.246 12.70425"
        />
        <linearGradient
          id="linearGradient1"
          x1="33.224937"
          y1="16.102583"
          x2="18.940542"
          y2="25.351179"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.081" stopColor="#69d3a7" stopOpacity="1" />
          <stop offset="1" stopColor="#69d3a7" stopOpacity="0" />
        </linearGradient>
        <path
          id="path1"
          fill="url(#linearGradient1)"
          stroke="none"
          d="M 20.663 31.282499 L 20.0165 29.150499 C 25.85 27.379 29.77025 22.0945 29.77025 16.001751 C 29.77025 14.320999 29.470501 12.6775 28.87775 11.12125 L 30.959249 10.32975 C 31.650101 12.141994 32.00285 14.065542 32 16.004999 C 31.99675 23.081249 27.443001 29.221251 20.663 31.282499"
        />
        <path
          id="path2"
          fill="#69d3a7"
          stroke="none"
          d="M 29.1675 11.973499 C 27.38575 6.16025 22.0945 2.2565 15.99825 2.2565 C 15.171648 2.25663 14.34668 2.329916 13.533 2.4755 L 13.13875 0.283001 C 14.082468 0.113256 15.039388 0.027586 15.99825 0.027 C 23.077999 0.027 29.224751 4.563749 31.296 11.31675 Z"
        />
        <linearGradient
          id="linearGradient2"
          x1="10.672573"
          y1="0.228997"
          x2="1.698604"
          y2="19.261801"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1e-05" stopColor="#69d3a7" stopOpacity="1" />
          <stop offset="0.823" stopColor="#2ab586" stopOpacity="1" />
          <stop offset="1" stopColor="#1cae7f" stopOpacity="1" />
        </linearGradient>
        <path
          id="path3"
          fill="url(#linearGradient2)"
          stroke="none"
          d="M 1.024 21.632999 C 0.3435 19.834499 0 17.93825 0 16.001751 C 0 7.75 6.194 0.916 14.4085 0.1075 L 14.6275 2.32375 C 7.558 3.02125 2.22625 8.901749 2.22625 16.001499 C 2.224128 17.656912 2.521938 19.299013 3.10525 20.848249 Z"
        />
        <path
          id="path4"
          fill="#fff"
          stroke="none"
          d="M 16.0825 10.723999 L 20.4475 21.407499 L 17.268 29.120001 L 19.494249 29.564751 L 27.234249 10.723751 L 24.82925 10.723751 L 21.740999 18.55125 L 18.62875 10.723751 Z"
        />
        <linearGradient
          id="linearGradient3"
          x1="-0.022713"
          y1="23.315021"
          x2="23.508358"
          y2="30.699967"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.077" stopColor="#1cae7f" stopOpacity="1" />
          <stop offset="0.164" stopColor="#1ca379" stopOpacity="1" />
          <stop offset="0.316" stopColor="#1c8568" stopOpacity="1" />
          <stop offset="0.516" stopColor="#1b554d" stopOpacity="1" />
          <stop offset="0.719" stopColor="#1b1e2e" stopOpacity="1" />
        </linearGradient>
        <path
          id="path5"
          fill="url(#linearGradient3)"
          stroke="none"
          d="M 17.668751 28.150249 L 17.20075 29.28525 C 17.093 29.54475 16.847 29.723249 16.570749 29.73325 C 16.379 29.74 16.19025 29.74675 15.995 29.74675 C 9.882 29.74675 4.439 25.654499 2.7585 19.79425 L 0.61625 20.407 C 2.56975 27.214001 8.89175 31.9695 15.9915 31.973 L 15.995 31.973 C 16.217251 31.973 16.439501 31.969749 16.661751 31.959499 C 17.803499 31.9125 18.824249 31.195 19.261749 30.134001 L 19.89525 28.594999 Z"
        />
      </DarkMode>
    </>
  )
}
